var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("ATH GAMES")]),_c('h2',{staticClass:"hr"},[_vm._v("TIME TO RAISE THE BAR")])])}]

export { render, staticRenderFns }